module.exports = __webpack_public_path__ + "static/media/unavailable-page.b1eb11b8.svg";